<template>
  <b-modal size="lg" :id="nameModal" hide-footer hide-header @show="showForm = true" @hidden="showForm = false">
    <div class="summaryForm">
      <button class="closeModal" @click="$bvModal.hide(nameModal)">
        <b-icon-x scale="1.3" />
      </button>
      <Applicator
        v-if="showForm"
        :idApplicatorFromSearch="idApplicatorFromSearch"
        @saved="$emit('getAllNewApplicator', $event)"
      />
    </div>
  </b-modal>
</template>

<script>
import Applicator from "../Applicator/Applicator.vue";

export default {
  components: { Applicator },
  props: {
    nameModal: { type: String, default: "modalCreateApplicator" },
    idApplicatorFromSearch: { type: String, default: "" },
  },
  data() {
    return { showForm: false };
  },
};
</script>

<style scoped>
.summaryForm { display: flex; flex-direction: column; color: #006256; }
.closeModal { position: absolute; top: 5px; right: 5px; z-index: 1000; color: #f99; cursor: pointer; border: 1px solid #eee; padding: 2px 3px; border-radius: 4px; }
.closeModal:hover { color: red; background: #f5f5f5; }
</style>
